module.exports = __webpack_public_path__ + "media/images/emblems/Rossa_wappen-e3f8d5afc686a4be340428d04167f3a4.svg";